import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import WalletContextProvider from './contexts/WalletContext';
import LandingPage from './components/LandingPage';
import OraclePage from './components/OraclePage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/core" element={
            <WalletContextProvider>
              <OraclePage />
            </WalletContextProvider>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 